import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { StartedFrom } from './types';

const selectState = (state: RootState): RootState['meta'] => state.meta;

export const selectStartedFrom = createSelector(
    [(state: RootState) => selectState(state).startedFrom],
    (startedFrom) => startedFrom,
);

export const selectIsFromSearchApp = createSelector(
    [(state: RootState) => selectStartedFrom(state)],
    (startedFrom) => {
        if (startedFrom === undefined) {
            return undefined;
        }

        return startedFrom === StartedFrom.SEARCH_APP;
    },
);

export const selectIsFromProducts = createSelector(
    [(state: RootState) => selectStartedFrom(state)],
    (startedFrom) => {
        if (startedFrom === undefined) {
            return undefined;
        }

        return startedFrom === StartedFrom.PRODUCTS;
    },
);

export const selectIsFromYaRu = createSelector(
    [(state: RootState) => selectStartedFrom(state)],
    (startedFrom) => {
        if (startedFrom === undefined) {
            return undefined;
        }

        return startedFrom === StartedFrom.YARU || startedFrom === StartedFrom.YARU_PRODUCTS;
    },
);
